import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StopPendingEffectsService {
  private stop$ = new Subject<void>();

  get stopObservable$() {
    return this.stop$.asObservable();
  }

  triggerStop() {
    this.stop$.next();
  }
}
